import { HomepageNewsletterMobile } from 'components/eventView/addons/homepageNewsletter/HomepageNewsletterMobile';
import { OverviewButtonsV1 } from 'components/eventView/overview/OverviewButtonsV1';
import { OverviewButtonsV2 } from 'components/eventView/overview/OverviewButtonsV2';
import { OverviewLinks } from 'components/eventView/overview/OverviewLinks';
import { EntityListItem } from 'elements/eventView/atomic/EntityListItem';
import { PageSection } from 'elements/eventView/layout/PageSection';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface IProps {
    className?: string;
}

export const EventViewOverviewPageContent = (props: IProps) => {
    const ctxEventView = useContext(CtxEventView);
    const { eventData, eventPath } = ctxEventView;

    // Currently not working, we need to get parameter for it and get the
    // right data from all entity lists
    const highlightedEntities = [];

    return (
        <S_EvenViewOverviewPageContent className={props.className}>
            {eventData.eventInfo.externalLinkPosition === 'top' && <OverviewLinks />}
            {eventData.eventInfo?.order?.normalV2 ? <OverviewButtonsV2 /> : <OverviewButtonsV1 />}
            {eventData.eventInfo.externalLinkPosition === 'bottom' && <OverviewLinks />}

            {highlightedEntities?.length > 0 && (
                <PageSection
                    titleIcon={{ iconPrefix: 'far', iconName: 'star' }}
                    title={Localization.HIGHLIGHTED}
                >
                    <S_EntityList>
                        {highlightedEntities.map((entity) => {
                            return (
                                <EntityListItem
                                    key={entity.storyId}
                                    entity={entity}
                                    mobilePathTo={`/event/${eventPath}/highlighted`}
                                />
                            );
                        })}
                    </S_EntityList>
                </PageSection>
            )}
            <>
                <S_HomepageNewsletterMobile />
            </>
            <>
                {eventData.eventInfo?.homepageContent?.footer
                    ? eventData.eventInfo.homepageContent.footer()
                    : null}
            </>
        </S_EvenViewOverviewPageContent>
    );
};

const S_EvenViewOverviewPageContent = styled.div`
    padding: 0 0 25px 0;
`;

const S_EntityList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const S_HomepageNewsletterMobile = styled(HomepageNewsletterMobile)`
    margin-top: 15px;
`;
